// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Universal Styles */
html {
  font-size: 18px;
}
body,
html {
  height: 100%;
  width: 100%;
  display: flex;
}

#root {
  height: 100%;
  width: 100%;
  display: flex;
}

@media only screen and (max-width: 560px) {
  html {
    font-size: 15px;
  }
}

input:focus {
  outline: none;
}

/* App Styles */

.App {
  font-family: "Catamaran", "Noto Color Emoji", sans-serif;
  background-size: cover;
  display: flex;
  flex-grow: 1;
  max-width: 100%;
}

h1 {
  padding: 0.66rem 0;
  text-align: center;
  font-size: 40px;
  margin: 0px;
  font-weight: 600;
}

.container {
  margin: 0 auto 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.content {
  display: flex;
  flex-grow: 1;
  justify-content: center;
}

a {
  color: #916db0;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/App/App.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;;AAEf;EACE,wDAAwD;EACxD,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":["/* Universal Styles */\nhtml {\n  font-size: 18px;\n}\nbody,\nhtml {\n  height: 100%;\n  width: 100%;\n  display: flex;\n}\n\n#root {\n  height: 100%;\n  width: 100%;\n  display: flex;\n}\n\n@media only screen and (max-width: 560px) {\n  html {\n    font-size: 15px;\n  }\n}\n\ninput:focus {\n  outline: none;\n}\n\n/* App Styles */\n\n.App {\n  font-family: \"Catamaran\", \"Noto Color Emoji\", sans-serif;\n  background-size: cover;\n  display: flex;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\nh1 {\n  padding: 0.66rem 0;\n  text-align: center;\n  font-size: 40px;\n  margin: 0px;\n  font-weight: 600;\n}\n\n.container {\n  margin: 0 auto 0 auto;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-grow: 1;\n  justify-content: center;\n}\n\na {\n  color: #916db0;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
